import styled from 'styled-components/macro'

const PollOptionsList = styled.ul`
  list-style-type: none;
  margin: 16px 16px 0px;
  padding: 0px;
`

export default PollOptionsList
